import { Box, Stack } from '@mui/material';
import { Link } from 'react-router-dom';

interface NavLogoProps {
  height?: number;
}

export function NavLogo({ height = 28 }: NavLogoProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      component={Link}
      to="/"
      sx={{ textDecoration: 'none', alignItems: 'center', flexShrink: 0 }}
    >
      <Box
        component="img"
        src="/logo.svg"
        alt="Rosta"
        sx={{
          height,
          display: 'block',
        }}
        onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
          e.currentTarget.style.display = 'none';
        }}
      />
    </Stack>
  );
}
